import $ from 'jquery'
import Backbone from 'backbone'
import template from './master-subscription-agreement-dialog.hbs'

var MasterSubscriptionAgreementDialog = Backbone.View.extend({

	className: 'master-subscription-agreement form',

	events: {
		'change .agreement-input': 'toggleContinue',
		'click .done' : 'accept'
	},

	render() {
		this.$el.empty().append(template())
		return this
	},

	close() {
		// issue #19933 prevent closing the dialog by pressing ESC
		// by implementing the close method but not triggering the close event
	},

	accept(e) {
		$.post(`api/admin/msa`).done(() => this.trigger('done'))
	},

	toggleContinue(e) {
		this.$('.done').prop('disabled', !$(e.currentTarget).is(':checked'))
	},

	remove() {
		Backbone.View.prototype.remove.apply(this, arguments)
		$(document).off('keyup', this._keyup)
	}
})

export default MasterSubscriptionAgreementDialog

MasterSubscriptionAgreementDialog.__filename__ = 'admin/master-subscription-agreement-dialog.js'
